import React from 'react';
import {Person} from "@material-ui/icons";
import { LinearProgress } from '@material-ui/core';
import LogoAnimation from '@views/Testing/components/LogoAnimation'

const UserProfile =React.lazy(()=>import('user/UserProfilePage'))

// error boundary
import ErrorBoundary from '@components/ErrorBoundary';
import { mainColor } from '~/assets/jss/material-dashboard-react/components/sidebarStyle';

const WithSuspError = (props) => {
  return (
    <ErrorBoundary>
       <React.Suspense fallback={<LogoAnimation/>}>
         {props.children}
       </React.Suspense>
    </ErrorBoundary>
  );
};

const rootRoutes = [
  {
    path: "/user",
    name: "User Profile",
    rtlName: "مشرف",
    icon: ()=> <Person style={{color:mainColor}} />,
    component: <WithSuspError><UserProfile/></WithSuspError>,
    layout: "/admin",
    navBarName:'User Profile'
  },
];

export default rootRoutes;